module.exports = __webpack_public_path__ + "img/content6.96506cec.png";